import { theme } from "@superhi/design";
import styled from "styled-components";

export const Inner = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media ${theme.breakpoints.medium} {
    flex-direction: row;
  }

  > * {
    width: 100%;

    &:first-child {
      margin-bottom: 12px;
    }

    @media ${theme.breakpoints.medium} {
      width: calc(50% - 12px);

      &:first-child {
        margin-bottom: 0;
      }
    }
  }
`;
